import { render, staticRenderFns } from "./MenuCloseIcon.vue?vue&type=template&id=31ee118e&"
import script from "./MenuCloseIcon.vue?vue&type=script&lang=js&"
export * from "./MenuCloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports